import firebase from "firebase";
import { Dispatch } from "redux";
import { resetCompany } from "../redux/actions/company";
import { resetContributor } from "../redux/actions/contributor";
import { resetInvoices } from "../redux/actions/invoices";

export default function logout(dispatch: Dispatch, history: any): void {
  firebase
    .auth()
    .signOut()
    .then(() => {
      history.push("/");
      dispatch(resetCompany());
      dispatch(resetContributor());
      dispatch(resetInvoices());
      window.fcWidget.user.clear();
    })
    .catch((err) => {
      console.log("Erro ao deslogar da aplicação.");
      console.log(err);
    });
}
